import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrown = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.0243 17.9168C12.1401 16.4603 7.85972 16.4603 3.97552 17.9168M16.6179 14.7562L18.6886 5.78322C18.8071 5.26993 18.1795 4.92208 17.807 5.29457C15.6776 7.42393 12.0648 6.68236 10.9464 3.88637L10.3089 2.29276C10.1973 2.01374 9.80235 2.01374 9.69075 2.29276L9.0533 3.88637C7.93491 6.68236 4.32205 7.42393 2.19269 5.29457C1.8202 4.92208 1.19259 5.26993 1.31104 5.78322L3.38173 14.7562C7.64872 13.1561 12.3509 13.1561 16.6179 14.7562Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCrown);
export default ForwardRef;
